import { format, parse } from 'date-fns';

export const formatDate = (date: Date | null): string => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};


export const parseStringToDate = (dateString: string): Date | null => {
    if (!dateString)
        return null;
    const [year, month, day] = dateString.
        split('-').map(Number);
    return new Date(year, month - 1, day);// Months are zero-based
};

export const parseStringToTime = (timeString: string): Date | null => {
    if (!timeString) return null;

    const [hours, minutes] = timeString.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0); // Set hours, minutes, seconds, and milliseconds
    return date;
};

export const formatDateString = (date: string): string => {
    const rawDate = new Date(date); // Example date
    const formattedDate = format(rawDate, 'yyyy-MM-dd');

    return formattedDate;
}

export const formatTimeTo12Hr = (time: string) => {
    const [hour, minute] = time.split(':');
    const date = new Date();
    date.setHours(Number(hour), Number(minute));
    return date
        .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })
        .toUpperCase();
};

export const formatPrice = (value: number) => {
    return new Intl.NumberFormat('en-UK', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
};

export const formatTo12HourTime = (timeStr: string | undefined | null): string => {
    if (!timeStr) return '';
    const parsed = parse(timeStr, 'HH:mm:ss', new Date());
    return format(parsed, 'hh:mm a');
};